import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { EdmMailer } from "./EDMMailer/EdmMailer";
import { Newsletter } from "./NewsLetter/Newsletter";
import { NotifcationSettings } from "./NotificationSettings/NotificationSettings";
import { Promotions } from "./Promotions/Promotions";
import { Users } from "./Users/Users";

export const Configuration = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(query.get("activeTab") || "notificationSettings");
  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/eraman/configuration?activeTab=${activeTab}`, {
        replace: true,
      });
    }
  }, []);

  const renderActiveTabContent = () => {
    switch (activeTab) {
      case "users":
        return <Users />;
      case "notificationSettings":
        return <NotifcationSettings />;
      case "edmMailer":
        return <EdmMailer />;
      case "newsLetter":
        return <Newsletter />;
      case "promotions":
        return <Promotions />;

      default:
        return null;
    }
  };

  const handleTabChange = (newActiveKey: any) => {
    setActiveTab(newActiveKey);
    navigate(`${window.location.pathname}?activeTab=${newActiveKey}`);
  };

  const items = [
    // {
    //   label: "Users",
    //   key: "users",
    // },
    {
      label: "Notification Settings",
      key: "notificationSettings",
    },
    {
      label: "EDM Mailer",
      key: "edmMailer",
    },
    {
      label: "Newsletter",
      key: "newsLetter",
    },
    {
      label: "Promotions",
      key: "promotions",
    },
  ];
  const handleButtons = (activeTab: any) => {
    if (activeTab === "users") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/configuration-users/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New User
        </Button>
      );
    } else if (activeTab === "newsLetter") {
      return (
        <Button
          onClick={() => {
            navigate(`/dedicated/eraman/configuration-newsLetter/add`);
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Newsletter Mail
        </Button>
      );
    } else if (activeTab === "promotions") {
      return (
        <Button
          onClick={() => {
            navigate(`/dedicated/eraman/configuration-promotions/add`);
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Promotion Mail
        </Button>
      );
    }
  };

  return (
    <ContentWrapper
      title={"Configuration"}
      actionItems={handleButtons(activeTab)}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={handleTabChange}
      ></Tabs>
      {renderActiveTabContent()}
    </ContentWrapper>
  );
};
